import React, { useEffect, useRef, useState } from 'react';
import './About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 } // Trigger slightly earlier
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <section className="about-section" id="about" ref={sectionRef}>
      <div className="container">
        <div className="about-grid">
          
          {/* --- LEFT SIDE: Image Composition --- */}
          <div className="about-image-wrapper">
            <div className="image-frame">
              <img 
                src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" 
                alt="Property Galleria Team" 
                className={`about-image ${isVisible ? 'in-view' : ''}`}
              />
            </div>
            
            {/* Floating Experience Badge */}
            <div className={`experience-badge ${isVisible ? 'in-view' : ''}`}>
              <span className="badge-number">20+</span>
              <span className="badge-text">Years Excellence</span>
            </div>
          </div>

          {/* --- RIGHT SIDE: Content --- */}
          <div className="about-content">
            <span className="section-subtitle">Who We Are</span>
            <h2 className="section-title">
              Realty Simplified. <br/>
              <span className="highlight-text">Trust Amplified.</span>
            </h2>
            <p className="about-desc">
              Property Galleria LLP is a client-focused realty advisory firm dedicated to making property and investment decisions simple, transparent, and profitable.We combine financial expertise with real estate insights to secure your future.
            </p>

            {/* Premium Mission/Vision Cards Container */}
            <div className="mv-container">
              
              {/* Mission Card */}
              <div className="mv-card">
                <div className="mv-icon-bg">🎯</div> {/* Watermark */}
                <div className="mv-header">
                  <div className="mv-icon-small">🎯</div>
                  <h4>Our Mission</h4>
                </div>
                <p>
                  We are committed to delivering personalized, transparent, and expert realty services.Our mission is to guide 1 million clients through every step of their real estate journey, offering reliable advice and tailored solutions that meet their unique needs.
                </p>
              </div>

              {/* Vision Card */}
              <div className="mv-card vision">
                <div className="mv-icon-bg">👁️</div> {/* Watermark */}
                <div className="mv-header">
                  <div className="mv-icon-small" style={{ color: 'var(--pg-secondary)' }}>👁️</div>
                  <h4>Our Vision</h4>
                </div>
                <p>
                  To be the most trusted and client-focused realty advisory company, empowering individuals and businesses with innovative solutions that simplify real estate decisions and lead to long-term success and satisfaction.
                </p>
              </div>

            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default About;